module.exports = __webpack_public_path__ + "img/videoproc.d7911ec4.svg";